export default __webpack_public_path__ + "static/media/ArrowLeft.937e7186.svg";